import Vue from 'vue'
import axios from "axios";
export default {
    data () {
        return {
           
        }
    },
    
    checkuserAccess: function(){
        let menuOutput = JSON.parse(localStorage.getItem("menu"));
        let flag = true;
        for (var i = 0; i < menuOutput.data.length; i++) {
        if (menuOutput.data[i].redirectingLink == localStorage.getItem('menuCliked')) {
         flag = false;
        }
       }

       if(localStorage.getItem('menuCliked').toUpperCase() == this.$route.path.replace('/','').toUpperCase())  
       flag = false;
       else flag = true;
       /* if flag is true ,redirect to login page*/
       if(flag == true){this.$router.push({name: 'Login'});}
      }
        


  }


// WEBPACK FOOTER //
// ./src/components/shared/shared.js